function addRadioButton() {
  const radioButtonsContainer = document.querySelector(".radio__buttons");
  let frmProducts = document.querySelector("[data-product-form]");
  let idTEmplateValue = frmProducts.children.namedItem("section-id").value;

  // Crea el span del nuevo radio
  const customOption = document.createElement("span");
  customOption.className = "radio__button";
  //options[Size]-template--17339424964677__mainproduct-3933106179-
  customOption.innerHTML = `
    <input 
      type="radio"
      form="${frmProducts.getAttribute("id")}"
      data-single-option-selector=""
      data-index="option1"
      name="options[Size]-${idTEmplateValue}product-${meta.product.id}-"
      value="6-Pack (6 x ${meta.product.variants[0].public_title})"
      id="caseSix"
      data-custom-option
    >
    <label for="caseSix">
<span>6-Pack (6 x ${meta.product.variants[0].public_title}) - Save 5%</span>
    </label>
  `;

  //add a input to single or case package

  radioButtonsContainer.appendChild(customOption);
  let lstRadioButtons = document.querySelectorAll(
    "span.radio__button >input[type='radio']"
  );

  //add event to change products
  lstRadioButtons.forEach((item) => {
    item.addEventListener("click", checkedRadio, false);
  });
}

function checkedRadio() {
  document
    .querySelectorAll("span.radio__button >input[type='radio']")
    .forEach((item) => {
      item.removeAttribute("checked");
    });
  this.setAttribute("checked", "");
  const isCaseSixBoxes = this.matches("input[data-custom-option]");
  changeOptionsBoxes(isCaseSixBoxes);
}

function changeOptionsBoxes(isCaseSixBoxes) {
  let frm = document.querySelector(".product-form");
  let productItem = document.querySelector(".product__submit__item input");
  productItem.value = isCaseSixBoxes ? 6 : 1;

  // Remover los inputs previos de propiedades si existen
  const existingCase = document.getElementById("typePackage");
  if (existingCase) existingCase.remove();

  const existingSize = document.getElementById("customSize");
  if (existingSize) existingSize.remove();


  

  if (isCaseSixBoxes) {
    // Agregar propiedad Case
    let typePackage = document.createElement("input");
    typePackage.id = "typePackage";
    typePackage.type = "hidden";
    typePackage.name = "properties[_Case]";
    typePackage.value = "Six Pack";
    frm.appendChild(typePackage);

    // Agregar propiedad Size personalizada
    let sizeProperty = document.createElement("input");
    sizeProperty.id = "customSize";
    sizeProperty.type = "hidden";
    sizeProperty.name = "properties[Size]";
    sizeProperty.value = `6-Pack (6 x ${meta.product.variants[0].public_title})`;
    frm.appendChild(sizeProperty);

    // Cambiar precio
    const unitPrice = meta.product.variants[0].price / 100; // Ej: 395
    const fullPrice =  (unitPrice * 6).toFixed(2) 
    const discount = (unitPrice*6 * 0.05).toFixed(1) 
   
    const totalDiscountedPrice = (fullPrice - discount).toFixed(2) ;
    
    // Mostrar el precio
    let priceLabel = document.querySelector(".product__price");
    priceLabel.innerHTML = `<span data-product-price>$${totalDiscountedPrice} </span>`;
  } else {
    // Resetear Size si es necesario
    let sizeProperty = document.createElement("input");
    sizeProperty.id = "customSize";
    sizeProperty.type = "hidden";
    sizeProperty.name = "properties[Size]";
    sizeProperty.value = `${meta.product.variants[0].public_title}`;

    frm.appendChild(sizeProperty);
  }
}

function increaseQuantity(event) {
  const idProduct = event.detail.item.id;

  const cartItems = Rebuy.SmartCart.items();
  const targetItem = cartItems.find((item) => item.id === idProduct);

  if (targetItem && targetItem.properties["_Case"]) {
    const newQuantity = targetItem.quantity + 6;
    Rebuy.Cart.setItemQuantity(targetItem, newQuantity);
  }
}

function decreaseQuantity(event) {
  const idProduct = event.detail.item.id;

  const cartItems = Rebuy.SmartCart.items();
  const targetItem = cartItems.find((item) => item.id === idProduct);

  if (targetItem && targetItem.properties["_Case"]) {
    const newQuantity = targetItem.quantity - 6;
    Rebuy.Cart.setItemQuantity(targetItem, newQuantity);
  }
}

function changeLabels() {
  const cartItems = Rebuy.SmartCart.items();
  
  const priceElements = document.querySelectorAll(
    "div.rebuy-cart__flyout-item-price .rebuy-money span[tabindex='0']"
  );
  const priceElementsBeforeDiscount = document.querySelectorAll(
    "div.rebuy-cart__flyout-item-price .rebuy-money.compare-at span:not(.sr-only)"
  );
  const quantityLabels = document.querySelectorAll(
    ".rebuy-cart__flyout-item-quantity-widget-label"
  );

  cartItems.forEach((item, index) => {
    if (
      item.properties &&
      item.properties["_Case"] &&
      item.properties["_Case"].toLowerCase() === "six pack"
    ) {

      const spanPrice = priceElements[index];
      const totalOutPriceDollars = ( item.original_price *6 / 100).toFixed(2);
      const totalDiscountPriceDollars = ( item.final_price *6 / 100).toFixed(2);
  
      if (!item.variant_title.includes("6-Pack")) {
        item.variant_title = "";
        item.variant_title = "6-Pack (6 x " + item.variant_options[0] + ")";
      }
      if (priceElementsBeforeDiscount[index]) {
        priceElementsBeforeDiscount[index].textContent = `$${totalOutPriceDollars}`;
      }
      if (spanPrice) {
        spanPrice.style.visibility = "hidden !important";
        spanPrice.textContent = "$" + totalDiscountPriceDollars; 
        spanPrice.style.visibility = "visible";
      }

      //  Mostrar cantidad como packs
      const label = quantityLabels[index];
      if (label) {
        const textNode = Array.from(label.childNodes).find(
          (node) => node.nodeType === 3 && node.textContent.trim().length > 0
        );
        if (textNode) {
          const packs = Math.floor(item.quantity / 6);
          textNode.textContent = packs;
        }
      }
    }
  });
}

// Ejecutar al cargar
document.addEventListener("DOMContentLoaded", () => {
  observeRebuyWidgetChanges();
  injectSixPackOptionIntoAllRebuyWidgets();
  //let isConcentrate = __st.pageurl.includes("tea-concentrate");
  let isLooseLeaf = meta.product.type.toLocaleLowerCase() == "loose leaf tea";
  if (!isLooseLeaf) addRadioButton();
  setTimeout(() => {
    changeLabels();
        

  }, 500);
   
});

// call add costume radio button

onload = (event) => {
  changeLabels();
  document.addEventListener(
    "rebuy:smartcart.line-item-increase",
    increaseQuantity,
    false
  );
  document.addEventListener(
    "rebuy:smartcart.line-item-decrease",
    decreaseQuantity,
    false
  );
  document.addEventListener("rebuy:cart.change", (event) => {
    startLoadingCart();
    setTimeout(() => {
      changeLabels();
      stopLoadingCart();
        refreshRebuyWidgets();

    }, 500);
  });
  document.addEventListener("rebuy:smartcart.show", function () {
    startLoadingCart();
    setTimeout(() => {
      changeLabels();
      stopLoadingCart();
     injectSixPackOptionIntoAllRebuyWidgets();
    }, 200);
  });
};
// Utilidad para truncar como en PDP (sin redondear)
function truncateDecimals(num, digits) {
  const factor = Math.pow(10, digits);
  return Math.floor(num * factor) / factor;
}

function injectSixPackOptionIntoAllRebuyWidgets() {
  const widgetSelectors = [
    "#rebuy-widget-15451 .rebuy-product-grid",
    "#rebuy-widget-18821 .rebuy-product-grid",
  ];

  widgetSelectors.forEach((gridSelector) => {
    const interval = setInterval(() => {
      const grid = document.querySelector(gridSelector);
      if (!grid) return;

      const productBlocks = grid.querySelectorAll(".rebuy-product-block");
      console.log(`✅ [${gridSelector}] Detectados ${productBlocks.length} bloques de producto`);

      productBlocks.forEach((block) => {
        const isLooseLeaf = block.classList.contains("tag-packagingloose-leaf");
        if (isLooseLeaf) {
          console.log("🚫 Producto excluido del 6-Pack (Loose Leaf)");
          return;
        }

        const select = block.querySelector("select.rebuy-select");
        const rebuyBtn = block.querySelector("button.rebuy-button");
        if (!select || !rebuyBtn) return;
        if (select.querySelector("option.six-pack-option")) return;

        const originalOption = select.options[0];
        const variantId = originalOption.value;
        const baseLabel = originalOption.textContent.trim();
        const priceContainer = block.querySelector(".rebuy-product-price span[tabindex='0']");

        // ➕ Crear opción "6-Pack"
        const packOption = document.createElement("option");
        packOption.value = variantId;
        packOption.textContent = `6 x ${baseLabel} (Save 5%)`;
        packOption.classList.add("six-pack-option");
        select.appendChild(packOption);

        // 🎯 Botón personalizado
        const customAddBtn = document.createElement("button");
        customAddBtn.type = "button";
        customAddBtn.className = "rebuy-button custom-sixpack-button";
        customAddBtn.style.display = "none";
        customAddBtn.innerHTML = "<span>Add 6-Pack</span>";

        customAddBtn.addEventListener("click", () => {
          console.log("🛒 Añadiendo 6-Pack al carrito...");

          const unitPrice = parseFloat(
            priceContainer?.dataset.basePrice || priceContainer?.textContent.replace("$", "") || "0"
          );
          const fullPrice = Math.floor(unitPrice * 6 * 10) / 10;
          const discounted = Math.floor((fullPrice - (fullPrice * 0.05)) * 10) / 10;

          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: variantId,
              quantity: 6,
              properties: {
                _Case: "Six Pack",
                Size: `6-Pack (6 x ${baseLabel})`,
              },
            }),
          })
            .then((res) => res.json())
            .then(() => {
              console.log("✅ 6-Pack agregado al carrito");
              setTimeout(() => {
                refreshRebuyWidgets();
              }, 300);
            });
        });

        rebuyBtn.parentNode.insertBefore(customAddBtn, rebuyBtn.nextSibling);

        select.addEventListener("input", () => {
          const selected = select.options[select.selectedIndex];
          const isSixPack = selected.classList.contains("six-pack-option");

          requestAnimationFrame(() => {
            if (isSixPack) {
              select.selectedIndex = -1;
              select.selectedIndex = Array.from(select.options).findIndex((opt) =>
                opt.classList.contains("six-pack-option")
              );
            }
          });

          if (isSixPack) {
            rebuyBtn.style.display = "none";
            customAddBtn.style.display = "inline-block";

            if (priceContainer) {
              const unitPrice = parseFloat(
                priceContainer.dataset.basePrice || priceContainer.textContent.replace("$", "") || "0"
              );
              const fullPrice = Math.floor(unitPrice * 6 * 10) / 10;
              const discounted = Math.floor((fullPrice - (fullPrice * 0.05)) * 10) / 10;
              priceContainer.textContent = `$${discounted.toFixed(2)}`;
            }
          } else {
            if (priceContainer) {
              const basePrice = parseFloat(priceContainer.dataset.basePrice || "0");
              priceContainer.textContent = `$${basePrice.toFixed(2)}`;
            }
            rebuyBtn.style.display = "inline-block";
            customAddBtn.style.display = "none";
          }
        });

        if (priceContainer && !priceContainer.dataset.basePrice) {
          const current = parseFloat(priceContainer.textContent.replace("$", "") || "0");
          priceContainer.dataset.basePrice = current;
        }

        select.selectedIndex = 0;
        select.dispatchEvent(new Event("input"));
      });

      clearInterval(interval);
    }, 400);
  });
}


function observeRebuyWidgetChanges() {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        console.log("🔁 Widget actualizado, reinyectando opciones 6-Pack");
        injectSixPackOptionIntoAllRebuyWidgets();
        break;
      }
    }
  });

  const widgetRoots = [
    document.querySelector("#rebuy-widget-15451 .rebuy-product-grid"),
    document.querySelector("#rebuy-widget-18821 .rebuy-product-grid"),
  ];

  widgetRoots.forEach((root) => {
    if (root) {
      observer.observe(root, { childList: true, subtree: true });
    }
  });
}




function startLoadingCart() {
  const cartContainer = document.querySelector(".rebuy-cart__flyout-items");
  const subtotalContainer = document.querySelector(
    ".rebuy-cart__flyout-subtotal"
  );

  if (cartContainer) cartContainer.classList.add("loading");
  if (subtotalContainer) subtotalContainer.classList.add("loading");
}

function stopLoadingCart() {
  const cartContainer = document.querySelector(".rebuy-cart__flyout-items");
  const subtotalContainer = document.querySelector(
    ".rebuy-cart__flyout-subtotal"
  );

  if (cartContainer) cartContainer.classList.remove("loading");
  if (subtotalContainer) subtotalContainer.classList.remove("loading");
}
function truncateDecimals(num, digits) {
  const factor = Math.pow(10, digits);
  return Math.floor(num * factor) / factor;
}

function refreshRebuyWidgets(widgetIds = [15451, 18821]) {
  widgetIds.forEach((id) => {
    const widget = document.querySelector(`[data-rebuy-id="${id}"]`);
    if (widget) {
      console.log(`🔁 Forzando refresh widget #${id}`);
      widget.innerHTML = ""; // Eliminar contenido actual
      widget.removeAttribute("data-initialized"); // Obliga a Rebuy a re-renderizar
    }
  });

  // Esperar y volver a inyectar opciones 6-Pack
  setTimeout(() => {
    injectSixPackOptionIntoAllRebuyWidgets();
  }, 1000);
}